import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface ChannelProps {
  iconSrc: string;
}

export const MobileFixedChannels = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: ${ColorPalette.HEX.White};
  padding: 16px;
`;

export const MobileChannelsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: auto;
`;

export const CountryName = styled.h4`
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: -0.2px;
  color: ${ColorPalette.HEX.DimGray};
`;

export const DesktopChannelsContainer = styled.div`
  margin-top: 32px;
`;

export const DesktopCountryContainer = styled.div`
  margin-bottom: 32px;
`;

export const DesktopChannel = styled.div<ChannelProps>`
  background-image: ${({ iconSrc }) => `url(${iconSrc})`};
  background-repeat: no-repeat;
  background-position: left center;
  background-size: 24px;

  margin: 12px 0;

  & > span {
    color: ${ColorPalette.HEX.DimGray};
    font-size: 20px;
    line-height: 28px;
    margin-left: 40px;
  }
`;
